<template>
  <spring-spinner :style="styleSpiner" :color="$themes.primary" v-if="isLoading" />
  <div class="row" v-else>
    <div class="flex xs12 xl6">
      <va-card :title="
        $t('users.singleTitle') + ' ' + user.first_name + ' ' + user.last_name
      ">
        <ul>
          <li>
            <img :style="styleAvatar" :src="user.avatar" />
          </li>
          <li>
            <span>{{ $t("users.first_name") }}:</span> {{ user.first_name }}
          </li>
          <li>
            <span>{{ $t("users.last_name") }}:</span> {{ user.last_name }}
          </li>
          <li>
            <span>{{ $t("users.location") }}:</span> {{ user.location }}
          </li>
          <li>
            <span>{{ $t("users.speaks") }}:</span> {{ user.speaks.join(",") }}
          </li>
          <li>
            <span>{{ $t("users.email") }}:</span> {{ user.email }}
          </li>
          <li>
            <span>{{ $t('users.profits') }}:</span> {{ user.profits }}$
          </li>
          <li>
            <span>{{ $t("users.phone") }}:</span> {{ user.phone }}
          </li>
          <li>
            <span>{{ $t("users.bio") }}:</span> {{ user.bio }}
          </li>
          <li>
            <span>{{ $t("users.zip") }}:</span> {{ user.zip }}
          </li>
          <li>
            <span>{{ $t("users.borrower_rating") }}:</span>
            {{ user.borrower_rating }}
          </li>
          <li>
            <span>{{ $t("users.lender_rating") }}:</span>
            {{ user.lender_rating }}
          </li>
          <li>
            <span>{{ $t("users.is_banned") }}:</span>
            {{ user.is_banned ? "✔️" : "❌" }} <va-button v-if="user.is_banned" @click="unBlockUser(user.id)"
              icon="va-icon fa fa-check-circle-o" color="success">{{ $t('users.unButtonBlock') }}</va-button>
          </li>
          <li>
            <span>{{ $t("users.birth_date") }}:</span>
            {{ moment(user.birth_date).format("L") }}
          </li>
          <li>
            <span>{{ $t("users.last_login") }}:</span>
            {{ moment(user.last_login).format("L") }}
          </li>
          <li>
            <span>{{ $t("users.date_joined") }}:</span>
            {{ moment(user.date_joined).format("L") }}
          </li>
          <li>
            <span>{{ $t("users.lender_rating_quantity") }}:</span>
            {{ user.lender_rating_quantity }}
          </li>
          <li>
            <span>{{ $t("users.borrower_rating_quantity") }}:</span>
            {{ user.borrower_rating_quantity }}
          </li>
          <li>
            <span>{{ $t("users.wishlists_publications") }}:</span>
            <router-link v-for="publication in user.wishlists_publications" :key="publication"
              :to="{ name: 'publications-single', params: { id: publication } }">/{{ publication }}</router-link>
          </li>
          <li>
            <span>{{ $t("users.wishlists_live_search") }}:</span>
            <router-link v-for="publication in user.wishlists_live_search" :key="publication"
              :to="{ name: 'publications-single', params: { id: publication } }">/{{ publication }}</router-link>
          </li>
        </ul>
        <p v-if="user.bans_history.length" class="display-3 pt-3 pb-2">{{ $t("users.bans_history") }}</p>
        <ul>
          <li class="ban" v-for="(ban, i) in user.bans_history" :key="i">
            <div>
              <span>{{ $t("users.when") }}:</span>
              <i> {{ moment(ban.when).format("L") }}</i>
            </div>
            <div>
              <span>{{ $t("users.until") }}:</span>
              <i> {{ moment(ban.until).format("L") }}</i>
            </div>
            <div>
              <span>{{ $t("users.days") }}:</span> <i> {{ ban.days }}</i>
            </div>
            <div>
              <span>{{ $t("users.in_process") }}:</span>
              <i> {{ ban.in_process ? "✔️" : "❌" }}</i>
            </div>
            <div v-if="ban.description">
              <span>{{ $t("users.description") }}:</span>
              <i> {{ ban.description }}</i>
            </div>
          </li>
        </ul>
        <ul>
          <li>
            <span>{{ $t("users.publications") }}: {{ user.publications.length }}</span>
          </li>
          <li :style="{ marginLeft: '50px' }" v-for="publication in user.publications" :key="publication.id">
            <router-link :to="{ name: 'publications-single', params: { id: publication.id } }">{{ publication.title }}
            </router-link>
          </li>
        </ul>
      </va-card>
    </div>
    <div class="flex xs12 xl6">
      <va-card :title="
        $t('users.titleActions') +' ' +user.first_name + ' ' +user.last_name
      ">
        <p class="display-4">{{ $t('settings.rogo_fee') }}</p>
        <va-input type="number" v-model="rogo_fee" :label="$t('settings.rogo_fee')">
          <va-button :disabled="rogo_fee === user.rogo_fee || rogo_fee < 0 || rogo_fee === ''" slot="append"
            @click="editSettings('rogo_fee')" style="margin-right: 0;" small>
            ✓
          </va-button>
        </va-input>
        <p class="display-4">{{ $t('users.sendNotification') }}</p>
        <notification-form :defaultUsers="[user.id]" :disabledSelectUser="true" :isFullScreen="false"
          @submit="sendNotification" />
        <p class="display-4 mt-4 mb-2">{{ $t('users.sendBan') }}</p>
        <form-ban @submit="sendBan" />

        <p class="display-4 mt-4 mb-2">{{ $t('users.removeTitle') }}</p>
        <form-delete @submit="deletingUser" :user-id="user.id" />
      </va-card>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { SpringSpinner } from 'epic-spinners'
import FormBan from './components/FormBan.vue'
import formDelete from './components/FormDelete.vue'
import NotificationForm from '../notification/components/NotificationForm.vue'
import moment from 'moment'
export default {
  data() {
    return {
      isLoading: true,
      rogo_fee: null,
      user: {},
    }
  },
  components: { SpringSpinner, NotificationForm, FormBan, formDelete },
  computed: {
    userID() {
      return this.$route.params.id
    },
    styleSpiner() {
      return {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
      }
    },
    styleAvatar() {
      return {
        maxWidth: '100px',
      }
    },
  },
  methods: {
    async deletingUser({ data, clear }) {
      const ask = data?.deleting && confirm('Are you sure? Do you want to delete this user?')
      this.skipLoading = true

      if (ask || !data?.deleting) {
        const res = await this.deleteUser(data)
        if (res.data?.detail) {
          alert(res.data?.detail)
        }
        if (res.data?.ok) {
          await this.setUser(false)
          this.showToast(
            res.data?.ok,
            {
              icon: 'fa-check',
              position: 'bottom-right',
              duration: 2500,
              fullWidth: false,
            },
          )
        } else {

        }
        clear()
        this.skipLoading = false
      }
      // this.$router.go(-1)
    },
    ...mapActions('Users', ['getUser', 'block', 'unBlock', 'sendNotification', 'setFee', 'deleteUser']),
    async editSettings(key) {
      const body = { id: this.user.id }
      body[key] = this[key]
      this.setFee(body)
      this.user[key] = body[key]
    },
    moment,
    async sendBan(data) {
      await this.block({ id: this.userID, data })
      this.setUser(false)
    },
    async setUser(isLoading = true) {
      this.isLoading = isLoading
      const response = await this.getUser(this.userID)
      this.user = response.data
      this.rogo_fee = this.user.rogo_fee
      this.isLoading = false
      if (response.status !== 200) {
        this.$router.push({ name: 'users' })
      }
    },
    async unBlockUser(id) {
      await this.unBlock(id)
      this.setUser(false)
    },
  },
  created() {
    this.setUser()
  },
}
</script>
<style lang="scss" scoped>
ul {
  li {
    font-size: 20px;

    span {
      font-weight: 600;
    }
  }

  .ban {
    padding: 15px;
    border: 1px solid var(--va-textColor);

    &:not(:last-child) {
      border-bottom: none;
    }
  }
}
</style>
